import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { Person } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = {
  rewardQuota: number;
  className?: string;
};

const OfferRewardQuota = ({ rewardQuota, className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <Icon />
      <Label>
        <FormattedMessage id="offer_reward_quota_display.label" />:
      </Label>
      <Quota>{rewardQuota}</Quota>
    </Root>
  );
};

const Root = styled('div')({
  display: 'inline-flex',
  ...flexibleLayoutContainer({
    direction: 'row',
    alignItems: 'center',
  }),
});

const Icon = styled(Person)({
  marginRight: SPACING_UNIT,
});

const Label = styled(Typography)({
  marginRight: '0.5em',
  fontSize: 12,
  fontWeight: 500,
  whiteSpace: 'nowrap',
});

const Quota = styled(Typography)({
  fontWeight: 500,
});

export default OfferRewardQuota;
